import {
    moveToFolderNewFolderText,
    moveToArchiveMbxFolderNewFolderText,
    searchFolder,
    searchArchiveFolder,
    moveToSearchSharedFolder,
    moveToFolderCreateNewText,
    moveToArchiveMbxFolderCreateNewText,
} from './moveToStringUtils.locstring.json';
import loc, { format } from 'owa-localize';
import MoveToMailboxContext from '../store/schema/MoveToMailboxContext';

import getMailboxTable from 'owa-folders/lib/selectors/getMailboxTable';
import { getStore } from '../store/store';

/**
 * New folder menu item's text in moveTo mailbox menu
 */
export function getMoveToNewFolderText(moveToMailboxContext: MoveToMailboxContext) {
    switch (moveToMailboxContext) {
        case 'primary':
            return loc(moveToFolderNewFolderText);

        case 'archive':
            return loc(moveToArchiveMbxFolderNewFolderText);

        case 'sharedFolder':
            return '';

        default:
            throw new Error('Correct movetocontext should be set');
    }
}

/**
 * The placeholder text for search box
 */
export function getSearchBoxLabelText(moveToMailboxContext: MoveToMailboxContext) {
    const { moveToSharedFolderRootId } = getStore();
    switch (moveToMailboxContext) {
        case 'primary':
            return loc(searchFolder);

        case 'archive':
            return loc(searchArchiveFolder);

        case 'sharedFolder':
            return format(
                loc(moveToSearchSharedFolder),
                getMailboxTable().get(moveToSharedFolderRootId).rootFolder.DisplayName
            );

        default:
            throw new Error('Correct movetocontext should be set');
    }
}

/**
 * Whevener the find text is not matched with any folder in moveTo mailbox menu then an item for create new folder with that same name is shown
 * This function returns what name should be shown in that item
 */
export function getNewFolderTextFromFindText(moveToMailboxContext: MoveToMailboxContext) {
    switch (moveToMailboxContext) {
        case 'primary':
            return loc(moveToFolderCreateNewText);

        case 'archive':
            return loc(moveToArchiveMbxFolderCreateNewText);

        case 'sharedFolder':
            return '';

        default:
            throw new Error('Correct moveto context should be set');
    }
}
